/* Card prices mirror the cart's pricing: once the cart holds the item
   minimum, the shopper's rate (club rate for members/club-selected carts,
   guest rate otherwise) applies to every card, from the same published
   config the drawer uses. Server renders undiscounted; this repaints. */
(function () {
  if (window.__millianCardPricing) return;
  window.__millianCardPricing = true;

  // Toast: "Item added to your cart" + VIEW CART, Dossier-style.
  window.millianToast = function (message) {
    var old = document.getElementById('millian-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.id = 'millian-toast';
    t.innerHTML =
      '<span class="millian-toast__check">&#10003;</span>' +
      '<span class="millian-toast__msg"></span>' +
      '<button type="button" class="millian-toast__view">VIEW CART</button>';
    t.querySelector('.millian-toast__msg').textContent = message || 'Item added to your cart';
    t.querySelector('.millian-toast__view').addEventListener('click', function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      t.remove();
    });
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { t.remove(); }, 300);
    }, 3500);
  };

  // Swap server-bundled sections from a cart API response (single round
  // trip - no separate section fetch).
  window.millianApplySections = function (sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var next = doc.querySelector('#CartDrawer');
      var cur = document.getElementById('CartDrawer');
      if (next && cur) cur.innerHTML = next.innerHTML;
      var curEl = document.querySelector('cart-drawer');
      var nextEl = doc.querySelector('cart-drawer');
      if (curEl && nextEl) curEl.classList.toggle('is-empty', nextEl.classList.contains('is-empty'));
    }
    if (sections['cart-icon-bubble']) {
      var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var bnext = bdoc.querySelector('.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bnext && bubble) bubble.innerHTML = bnext.innerHTML;
    }
  };

  function fmt(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'AUD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }
  function setHidden(node, value) {
    if (node && node.hidden !== value) node.hidden = value;
  }

  function paint() {
    var cards = document.querySelectorAll('[data-millian-card-price]');
    if (!cards.length) return;
    var pct = 0;
    var stateEl = document.querySelector('[data-millian-cart-state]');
    if (stateEl) {
      try {
        var state = JSON.parse(stateEl.textContent);
        var pricing = state.pricing;
        var memberish =
          document.documentElement.classList.contains('millian-is-member') ||
          document.documentElement.classList.contains('millian-club-selected') ||
          Boolean(state.clubSelected);
        if (pricing && (state.count || 0) >= pricing.minItems) {
          pct = memberish ? pricing.memberPercent : pricing.guestPercent;
        }
      } catch (e) { pct = 0; }
    }

    cards.forEach(function (el) {
      var cents = Number(el.getAttribute('data-cents')) || 0;
      var compare = Number(el.getAttribute('data-compare-cents')) || 0;
      var currency = el.getAttribute('data-currency') || 'AUD';
      var sale = Math.round(cents * (100 - pct) / 100);
      var was = Math.max(cents, compare);
      var saleEl = el.querySelector('.millian-price__sale');
      var wasEl = el.querySelector('.millian-price__was');
      setText(saleEl, fmt(sale, currency));
      var badgeEl = el.querySelector('.millian-card-tag__badge');
      if (wasEl) {
        if (was > sale) {
          setText(wasEl, fmt(was, currency));
          setHidden(wasEl, false);
        } else {
          setHidden(wasEl, true);
        }
      }
      if (badgeEl) {
        var shownPct = was > sale ? Math.round((was - sale) * 100 / was) : 0;
        setText(badgeEl, '-' + shownPct + '%');
        setHidden(badgeEl, shownPct <= 0);
        if (el.classList.contains('is-discounted') !== shownPct > 0) {
          el.classList.toggle('is-discounted', shownPct > 0);
        }
      }
    });

    // BNPL badges (ported snippet renders price/4 server-side): keep the
    // 4X instalment amounts in sync with the live tier price.
    var prod = document.querySelector('.millian-price--product[data-millian-card-price]');
    if (prod) {
      var pCents = Number(prod.getAttribute('data-cents')) || 0;
      var pCurrency = prod.getAttribute('data-currency') || 'AUD';
      var pSale = Math.round(pCents * (100 - pct) / 100);
      var instalment = fmt(Math.round(pSale / 4), pCurrency);
      document
        .querySelectorAll('.afterpay-paragraph-1 .afterpaytext strong, .afterpay-paragraph-2 .afterpaytext strong')
        .forEach(function (el) { setText(el, instalment); });
    }
  }

  window.millianPaintCardPrices = paint;

  // Quick add: first available variant, then refresh + open the drawer.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-millian-card-atc]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var original = btn.textContent.trim();
    btn.textContent = 'ADDING...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('quick add failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        btn.textContent = 'ADDED';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1200);
        window.millianApplySections(data.sections);
        window.millianToast();
        // Lightweight signal (drawer state, strip) that does NOT trigger
        // another section fetch.
        document.dispatchEvent(new CustomEvent('cart-update', { detail: { source: 'millian-quick-add' } }));
      })
      .catch(function (err) {
        console.error('[millian] quick add:', err);
        btn.textContent = original;
        btn.disabled = false;
      });
  });

  var queued = null;
  function queue() {
    if (queued) return;
    queued = setTimeout(function () { queued = null; paint(); }, 100);
  }
  function schedule() {
    paint();
    [300, 1500, 3000].forEach(function (ms) { setTimeout(paint, ms); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  // The member/club classes arrive async on <html> — repaint when they flip.
  new MutationObserver(queue).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
  document.addEventListener('update-cart-drawer', queue);
  // Drawer re-renders (quick add, upsell add, qty changes) replace the
  // Popular Scents cards with server-rendered full prices: repaint them.
  document.addEventListener('cart-update', queue);
  var drawerRoot = document.getElementById('CartDrawer');
  if (drawerRoot) {
    new MutationObserver(queue).observe(drawerRoot, { childList: true, subtree: true });
  }
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble) {
    new MutationObserver(queue).observe(bubble, { childList: true, subtree: true, characterData: true });
  }
})();
